const HUBSPOT_PORTAL_ID = '45126382';
const HUBSPOT_FORM_ID = 'b57a4b4b-95df-4458-a99b-0f8218d06961';
const HUBSPOT_FORM_TARGET_ID = 'rv-hubspot-form-target';

const pushFormEvent = () => {
  window.dataLayer = window.dataLayer || [];
  if (!window.dataLayer.some((e) => e.event === 'form_submitted_success')) {
    window.dataLayer.push({ event: 'form_submitted_success' });
  }
};

window.addEventListener('message', (event) => {
  if (!event.data || typeof event.data !== 'object') return;

  const { origin, data } = event;

  // Format 1: new ui-forms-embed — from forms.hsforms.com
  if (
    origin === 'https://forms.hsforms.com'
    && data.formGuid === HUBSPOT_FORM_ID
    && data.accepted === true
  ) {
    pushFormEvent();
    return;
  }

  // Format 2: hsFormCallback — from js.hsforms.net (classic forms/v2.js)
  if (
    (origin === 'https://js.hsforms.net' || origin === 'https://forms.hsforms.com')
    && data.type === 'hsFormCallback'
    && data.eventName === 'onFormSubmitted'
    && (data.id === HUBSPOT_FORM_ID || !data.id)
  ) {
    pushFormEvent();
  }
});

const watchFormHeight = (target) => {
  const startWatchingFrame = (frame) => {
    let initialHeight = null;

    const mo = new MutationObserver(() => {
      const h = parseFloat(frame.style.height);
      if (!initialHeight && h > 250) initialHeight = h;
      if (initialHeight && h > 0 && h < initialHeight * 0.5) {
        mo.disconnect();
        pushFormEvent();
      }
    });

    mo.observe(frame, { attributes: true, attributeFilter: ['style'] });
  };

  const existing = target.querySelector('.hs-form-frame');
  if (existing) {
    startWatchingFrame(existing);
    return;
  }

  const childMo = new MutationObserver(() => {
    const frame = target.querySelector('.hs-form-frame');
    if (frame) {
      childMo.disconnect();
      startWatchingFrame(frame);
    }
  });

  childMo.observe(target, { childList: true, subtree: true });
};

const initHubSpotForm = () => {
  if (!window.hbspt) return;

  const target = document.getElementById(HUBSPOT_FORM_TARGET_ID);
  if (!target || target.dataset.hsInitialized) return;
  target.dataset.hsInitialized = 'true';

  watchFormHeight(target);

  window.hbspt.forms.create({
    region: 'na1',
    portalId: HUBSPOT_PORTAL_ID,
    formId: HUBSPOT_FORM_ID,
    target: `#${HUBSPOT_FORM_TARGET_ID}`,
    onFormSubmitted: pushFormEvent,
  });
};

const buildModalMarkup = () => `
  <div class="contact-modal__backdrop" data-contact-modal-close></div>
  <div class="contact-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="contact-modal-title" tabindex="-1" data-lenis-prevent data-lenis-prevent-wheel data-lenis-prevent-touch>
    <button type="button" class="contact-modal__close" data-contact-modal-close aria-label="Fechar modal">×</button>
    <div class="contact-modal__content">
      <h2 class="contact-modal__title" id="contact-modal-title">Fale com a RV+</h2>
      <p class="contact-modal__description">Preencha o formulário abaixo e nossa equipe retorna o contato.</p>
      <div class="contact-modal__form"><div id="rv-hubspot-form-target"></div></div>
    </div>
  </div>
`;

const ensureModal = () => {
  let existingModal = document.querySelector('[data-contact-modal]');
  if (existingModal) {
    return existingModal;
  }

  existingModal = document.createElement('div');
  existingModal.className = 'contact-modal';
  existingModal.setAttribute('data-contact-modal', '');
  existingModal.hidden = true;
  existingModal.setAttribute('aria-hidden', 'true');
  existingModal.innerHTML = buildModalMarkup();
  document.body.appendChild(existingModal);
  return existingModal;
};

const modal = ensureModal();

if (modal) {
  const openButtons = document.querySelectorAll('[data-contact-modal-open]');
  const closeButtons = modal.querySelectorAll('[data-contact-modal-close]');
  const dialog = modal.querySelector('.contact-modal__dialog');
  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'textarea:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
  ].join(',');

  let lastFocusedElement = null;

  const getFocusableElements = () => Array.from(modal.querySelectorAll(focusableSelector))
    .filter((element) => element.offsetParent !== null || element === document.activeElement);

  const closeMobileMenu = () => {
    const hamburger = document.querySelector('.header__hamburger[aria-expanded="true"]');
    if (hamburger) {
      hamburger.click();
    }
  };

  const lockScroll = () => {
    document.body.classList.add('contact-modal-open');
  };

  const unlockScroll = () => {
    document.body.classList.remove('contact-modal-open');
  };

  const focusFirstElement = () => {
    const focusableElements = getFocusableElements();
    const target = focusableElements[0] || dialog || modal;
    if (target && typeof target.focus === 'function') {
      target.focus({ preventScroll: true });
    }
  };

  const openModal = () => {
    lastFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    closeMobileMenu();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    lockScroll();
    window.requestAnimationFrame(() => {
      modal.classList.add('is-open');
      focusFirstElement();
    });
  };

  const closeModal = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    unlockScroll();

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus({ preventScroll: true });
    }
  };

  window.abrirModal = openModal;
  window.fecharModal = closeModal;

  const hubspotScriptId = 'rv-hubspot-contact-form-script';
  if (!document.getElementById(hubspotScriptId)) {
    const script = document.createElement('script');
    script.id = hubspotScriptId;
    script.src = 'https://js.hsforms.net/forms/v2.js';
    script.addEventListener('load', initHubSpotForm);
    document.head.appendChild(script);
  } else if (window.hbspt) {
    initHubSpotForm();
  }

  openButtons.forEach((button) => {
    button.addEventListener('click', openModal);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeModal);
  });

  modal.addEventListener('click', (event) => {
    if (event.target === modal || event.target.matches('[data-contact-modal-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });
}
